<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo" [routerLink]="['/dashboard/default']">
              <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage" />
              <img
                class="img-fluid for-dark"
                src="assets/images/logo/logo_dark.png"
                alt="looginpage"
            /></a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>{{ 'login.sign_in_to_account' | translate }}</h4>
              <p>{{ 'login.enter_your_email_and_password' | translate }}</p>
              <div class="form-group">
                <label class="col-form-label">{{ 'form.email_address' | translate }}</label>
                <input
                  data-testid="email"
                  class="form-control"
                  type="email"
                  placeholder="Test@gmail.com"
                  formControlName="email"
                />
                @if (
                  loginForm.controls['email'].touched &&
                  loginForm.controls['email'].errors?.['required']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.required_field' | translate }}
                  </div>
                }
                @if (
                  loginForm.controls['email'].touched &&
                  loginForm.controls['email'].errors?.['email']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.invalid_field' | translate }}
                  </div>
                }
              </div>
              <div class="form-group">
                <label class="col-form-label">{{ 'form.password' | translate }}</label>
                <div class="form-input position-relative">
                  <input
                    data-testid="password"
                    class="form-control"
                    type="password"
                    name="login[password]"
                    [type]="show ? 'text' : 'password'"
                    placeholder="*********"
                    formControlName="password"
                  />
                  <div class="show-hide">
                    <span (click)="show = !show">
                      <i class="fa fs-5" [class.fa-eye]="show" [class.fa-eye-slash]="!show"></i>
                    </span>
                  </div>
                  @if (
                    loginForm.controls['password'].touched &&
                    loginForm.controls['password'].errors?.['required']
                  ) {
                    <div class="text text-danger mt-1">
                      {{ 'form.validations_error.required_field' | translate }}
                    </div>
                  }
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input
                    data-testid="remember-me"
                    id="rememberMe"
                    type="checkbox"
                    formControlName="rememberMe"
                  />
                  <label class="text-muted" for="rememberMe">{{
                    'login.remember_me' | translate
                  }}</label>
                </div>
                <a
                  class="link"
                  [routerLink]="['/auth/forgot-password']"
                  data-testid="forgot-password-link"
                  >{{ 'forgot-password.title' | translate }}</a
                >
                <div class="text-end mt-3">
                  <button
                    class="btn btn-primary btn-block w-100"
                    type="submit"
                    data-testid="login-button"
                    [disabled]="!loginForm.valid"
                    (click)="login()"
                  >
                    {{ 'buttons.sign_in' | translate }}
                  </button>
                </div>
              </div>
              <h6 class="text-muted mt-4 or">{{ 'login.or_sign_in_with' | translate }}</h6>
              <div class="social mt-4">
                <div class="btn-showcase">
                  <a class="btn btn-light" href="https://www.linkedin.com/login" target="_blank">
                    <app-feather-icons
                      [class]="'txt-linkedin'"
                      [icons]="'linkedin'"
                    ></app-feather-icons
                    >LinkedIn
                  </a>
                  <a class="btn btn-light" href="https://twitter.com/login?lang=en" target="_blank">
                    <app-feather-icons
                      [class]="'txt-twitter'"
                      [icons]="'twitter'"
                    ></app-feather-icons
                    >twitter
                  </a>
                  <a class="btn btn-light" href="https://www.facebook.com/" target="_blank">
                    <app-feather-icons [class]="'txt-fb'" [icons]="'facebook'"></app-feather-icons
                    >facebook
                  </a>
                </div>
              </div>
              <p class="mt-4 mb-0 text-center">
                {{ 'login.dont_have_account' | translate }}
                <a
                  class="ms-2"
                  [routerLink]="['/authentication/register-simple']"
                  data-testid="create-account-link"
                  >{{ 'buttons.create_account' | translate }}</a
                >
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
